import React from "react";

const Os = (props) => {
  const os = props.row.original.oS;
  return (
    <div className="dashboard__table__os">
      <p>
        {os === "linux22" ? "linux" : os === "macos16" ? "macos" : os === "andro13" ? "and13" : os}
      </p>
    </div>
  );
};

export default Os;
